<h2>Need Help?</h2>
<p>Read through popular questions and answers about NuLifeSpan Rx.</p>

<ul class="nav nav-tabs">
    <li><a  class="active" data-toggle="tab" href="#menu1">About NuLifeSpan Rx</a></li>
    <li><a data-toggle="tab" href="#menu2">How to Use NuLifeSpan Rx</a></li>
    <li><a data-toggle="tab" href="#menu3">Cashback Rewards</a></li>
    <li><a data-toggle="tab" href="#menu4">Going Pro</a></li>
    <li><a data-toggle="tab" href="#menu5">I Already Have Insurance</a></li>
    <li><a data-toggle="tab" href="#menu6">Legal and Compliance</a></li>
  </ul>
  
  <div class="tab-content">
    <div id="menu1" class="tab-pane fade in active show">
        <div class="panel-group" id="accordion">
            <div class="panel panel-default" *ngFor="let faq of faqData1; let i = index">
                <div class="panel-heading">
                    <h3 class="panel-title">
                        <span data-toggle="collapse" data-parent="#accordion" aria-expanded='false' id={{i}}
                            (click)="toggleCollapse(this.i, '#accordion')" class="removeAttr"><span>&nbsp;</span>{{faq.Question}}</span>
                    </h3>
                </div>
                <div id="collapse{{i}}" class="panel-collapse collapse in">
                    <div class="panel-body" [innerHTML]="faq.Answer"></div>
                    <ul>
                        <li *ngFor="let subAns of faq.SubAnswer" [innerHTML]="subAns.A"></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div id="menu2" class="tab-pane fade">
        <div class="panel-group" id="accordion2">
            <div class="panel panel-default" *ngFor="let faq of faqData2; let i = index">
                <div class="panel-heading">
                    <h3 class="panel-title">
                        <span data-toggle="collapse" data-parent="#accordion2" aria-expanded='false' id={{i}}
                            (click)="toggleCollapse(this.i, '#accordion2')" class="removeAttr"><span>&nbsp;</span>{{faq.Question}}</span>
                    </h3>
                </div>
                <div id="collapse{{i}}" class="panel-collapse collapse in">
                    <div class="panel-body" [innerHTML]="faq.Answer"></div>
                    <ul>
                        <li *ngFor="let subAns of faq.SubAnswer" [innerHTML]="subAns.A"></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div id="menu3" class="tab-pane fade">
        <div class="panel-group" id="accordion3">
            <div class="panel panel-default" *ngFor="let faq of faqData3; let i = index">
                <div class="panel-heading">
                    <h3 class="panel-title">
                        <span data-toggle="collapse" data-parent="#accordion3" aria-expanded='false' id={{i}}
                            (click)="toggleCollapse(this.i,'#accordion3')" class="removeAttr"><span>&nbsp;</span>{{faq.Question}}</span>
                    </h3>
                </div>
                <div id="collapse{{i}}" class="panel-collapse collapse in">
                    <div class="panel-body" [innerHTML]="faq.Answer"></div>
                    <ul>
                        <li *ngFor="let subAns of faq.SubAnswer" [innerHTML]="subAns.A"></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div id="menu4" class="tab-pane fade">
        <div class="panel-group" id="accordion4">
            <div class="panel panel-default" *ngFor="let faq of faqData4; let i = index">
                <div class="panel-heading">
                    <h3 class="panel-title">
                        <span data-toggle="collapse" data-parent="#accordion4" aria-expanded='false' id={{i}}
                            (click)="toggleCollapse(this.i,'#accordion4')" class="removeAttr"><span>&nbsp;</span>{{faq.Question}}</span>
                    </h3>
                </div>
                <div id="collapse{{i}}" class="panel-collapse collapse in">
                    <div class="panel-body" [innerHTML]="faq.Answer"></div>
                    <ul>
                        <li *ngFor="let subAns of faq.SubAnswer" [innerHTML]="subAns.A"></li>
                    </ul>
                </div>
            </div>
        </div>
      </div>
      <div id="menu5" class="tab-pane fade">
        <div class="panel-group" id="accordion5">
            <div class="panel panel-default" *ngFor="let faq of faqData5; let i = index">
                <div class="panel-heading">
                    <h3 class="panel-title">
                        <span data-toggle="collapse" data-parent="#accordion5" aria-expanded='false' id={{i}}
                            (click)="toggleCollapse(this.i,'#accordion5')" class="removeAttr"><span>&nbsp;</span>{{faq.Question}}</span>
                    </h3>
                </div>
                <div id="collapse{{i}}" class="panel-collapse collapse in">
                    <div class="panel-body" [innerHTML]="faq.Answer"></div>
                    <ul>
                        <li *ngFor="let subAns of faq.SubAnswer" [innerHTML]="subAns.A"></li>
                    </ul>
                </div>
            </div>
        </div>
      </div>
      <div id="menu6" class="tab-pane fade">
        <div class="panel-group" id="accordion6">
            <div class="panel panel-default" *ngFor="let faq of faqData6; let i = index">
                <div class="panel-heading">
                    <h3 class="panel-title">
                        <span data-toggle="collapse" data-parent="#accordion6" aria-expanded='false' id={{i}}
                            (click)="toggleCollapse(this.i,'#accordion6')" class="removeAttr"><span>&nbsp;</span>{{faq.Question}}</span>
                    </h3>
                </div>
                <div id="collapse{{i}}" class="panel-collapse collapse in">
                    <div class="panel-body" [innerHTML]="faq.Answer"></div>
                    <ul>
                        <li *ngFor="let subAns of faq.SubAnswer" [innerHTML]="subAns.A"></li>
                    </ul>
                </div>
            </div>
        </div>
      </div>
    </div>
